import {
    Card,
    CardBody,
    
    Typography,
    
  } from "@material-tailwind/react";



const Benifitbox = () => {
  return (
    
        <div className="maincontainer relative overflow-x-clip pb-20 sm:pb-20 bg-blue-100">
          <div className="container sm:container mx-auto md:container md:auto">
            <div className="headlinesboix lg:pt-5 lg:pb-10  flex justify-center">
              <div className="biglines  mt-10">
                <h1 className="fonting mx-auto max-w-5xl font-display text-4xl font-medium tracking-tight text-slate-900 sm:text-5xl">
                Advantages for Registering a Trademark
                </h1>
              </div>
            </div>
            <div className="contentbox w-full mx-auto mt-5">
              <Card className="mt-5">
                <CardBody>
                  <Typography variant="h5" color="blue-gray" className="mb-2 text-3xl">
                  Super Business Opportunity
                  </Typography>
                  <Typography className="text-lg">
                  Customers' perceptions of security, quality, and trust are bolstered by registered trademarks, which serve as promotional tools for the goods and services they market. When an identity is linked to few other merchants, it might be considered unique.
                  </Typography>
                </CardBody>
              </Card>
              {/** second card */}
              <Card className="mt-5">
                <CardBody>
                  <Typography variant="h5" color="blue-gray" className="mb-2 text-3xl">
                  Legal Protection
                  </Typography>
                  <Typography className="text-lg">
                  The owner of a registered trademark has all rights and may pursue legal action against you or anyone else for copying any portion of the trademark, including the logo registration, brand name, or slogan.
                  </Typography>
                </CardBody>
              </Card>
              {/** third card */}
              <Card className="mt-5">
                <CardBody>
                  <Typography variant="h5" color="blue-gray" className="mb-2 text-3xl">
                  Get yourself a Unique Identity
                  </Typography>
                  <Typography className="text-lg">
                  Customers are limited to viewing a single product or service under its specific name brand. By registering the mark, the business can be guaranteed that no one else will use it and that it is now its exclusive property.
                  </Typography>
                </CardBody>
              </Card>
              {/** fourth card */}
              <Card className="mt-5">
                <CardBody>
                  <Typography variant="h5" color="blue-gray" className="mb-2 text-3xl">
                  Global Trademark Application
                  </Typography>
                  <Typography className="text-lg">
                  It is permissible to register and file a trademark in India then other countries (that are outside India). Besides, foreign nationals may also register and file trademarks in India.
                  </Typography>
                </CardBody>
              </Card>
              <Card className="mt-5">
                <CardBody>
                  <Typography variant="h5" color="blue-gray" className="mb-2 text-3xl">
                  Are creating intangible assets
                  </Typography>
                  <Typography className="text-lg">
                  Your trademark could become a valuable asset if it gains popularity and success after being registered. An intangible asset that may be profitably bought, sold, leased, or even shared is an officially registered trademark. So, this benefits the company as well as the individual owner.
                  </Typography>
                </CardBody>
              </Card>
              <Card className="mt-5">
                <CardBody>
                  <Typography variant="h5" color="blue-gray" className="mb-2 text-3xl">
                  Advantages
                  </Typography>
                  <Typography className="text-lg">
                  The owner of the trademark who registered it may receive it along with certain exclusive rights. Within a category, a trademark may be registered for each product that is offered. When something has exclusive rights, it means that no one else with no permission can use it.

                  </Typography>
                </CardBody>
              </Card>
              <Card className="mt-5">
                <CardBody>
                  <Typography variant="h5" color="blue-gray" className="mb-2 text-3xl">
                  Utilizing symbols that are registered

                  </Typography>
                  <Typography className="text-lg">
                  Following the submission of your trademark application, you are permitted to use the registered trademark (®) symbol. Using this sign indicates that since this is already a registered trademark, no one else may submit a comparable application. In the event that someone uses their registered trademarks without authorization, they may file a lawsuit against the infringer of their rights.

                  </Typography>
                </CardBody>
              </Card>
              <Card className="mt-5">
                <CardBody>
                  <Typography variant="h5" color="blue-gray" className="mb-2 text-3xl">
                  Makes it easier to purchase goods or services


                  </Typography>
                  <Typography className="text-lg">
                  When a trademark is registered, a company releases its goods to the public. This sets them apart and encourages brand evolution. Businesses typically acquire their identity through the use of trademarks, which makes them crucial for the development or improvement of brand value.

                  </Typography>
                </CardBody>
              </Card>
            </div>
            <div className="headlinesboix lg:pt-5 lg:pb-10  flex justify-center">
              <div className="biglines  mt-10">
                <h1 className="fonting mx-auto max-w-5xl font-display text-4xl font-medium tracking-tight text-slate-900 sm:text-5xl">
                Steps to filing a trademark application
                </h1>
              </div>
            </div>
            <div className="contentbox w-full mx-auto mt-5">
              <Card className="mt-5">
                <CardBody>
                  <Typography variant="h5" color="blue-gray" className="mb-2 text-3xl">
                  Step 1: Search for trademarks (one day)

                  </Typography>
                  <Typography className="text-lg">
                  CA Solution ensures that they have looked and ascertained whether a trademark or brand registration name is available or if it is registered under a different class on behalf of its clients.

                  </Typography>
                </CardBody>
              </Card>
              {/** second card */}
              <Card className="mt-5">
                <CardBody>
                  <Typography variant="h5" color="blue-gray" className="mb-2 text-3xl">
                  Step 2: Create a trademark application (one day)
                  </Typography>
                  <Typography className="text-lg">
                  We will send you an authorization letter, which you must correctly sign in accordance with your specifications and return to us once we have confirmed that the name or design you have selected is available and unique. These letters authorize our attorneys to file trademark applications on your behalf.

                  </Typography>
                </CardBody>
              </Card>
              {/** third card */}
              <Card className="mt-5">
                <CardBody>
                  <Typography variant="h5" color="blue-gray" className="mb-2 text-3xl">
                  Step 3: Trademark application submission takes one day
                  </Typography>
                  <Typography className="text-lg">
                  As soon as we get the authorization letter, you can start using TM sign immediately, provided that all the details are filled in as they should be; this way our lawyers will file trademark registration for you respectively. From our side, you will be assigned a number of the TM application.

                  </Typography>
                </CardBody>
              </Card>
              {/** fourth card */}
              <Card className="mt-5">
                <CardBody>
                  <Typography variant="h5" color="blue-gray" className="mb-2 text-3xl">
                  Step 4: Register the trademark; it will require one and a half years.

                  </Typography>
                  <Typography className="text-lg">
                  The office will review your application after you submit it. For instance, the government can object if your name is thought to be impolite or insulting. Additionally, religious sentiments might be hurt if our trademark is compared to another in the same class. Thus, the trademark registrar will publish its advertisement in the trademark act journal if no objections are filed against it. A trademark must be registered during the next six months without fail if there is no opposition from any side within the first four months. We update you on the status of your application during this time.


                  </Typography>
                </CardBody>
              </Card>
              <Card className="mt-5">
                <CardBody>
                  <Typography variant="h5" color="blue-gray" className="mb-2 text-3xl">
                  Step 5: Hearing before Registrar
                  </Typography>
                  <Typography className="text-lg">
                  A hearing before the registrar will be held about your trademark if the opposition is not satisfied with your response following the filing of an object. For an additional fee, we retain attorneys to represent you in court before the registrar.

                  </Typography>
                </CardBody>
              </Card>
            </div>
            </div>
            </div>
  )
}

export default Benifitbox